// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./fonts/Museo Slab.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./fonts/OpenSans.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: 'Museo Slab';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  font-display: swap;
}
@font-face {
  font-family: 'Open Sans';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  font-display: swap;
}

.wildidea {
  --heading-font: 'Museo Slab';
  --body-font: 'Open Sans', sans-serif;
  --monospace-font: Menlo, Monaco, Consolas, 'Courier New', monospace;
}

/* begin structural style applications */
.wildidea {
  font-family: var(--body-font);
  /* Font Scaling from 320px - 1920px (4k is below) */
  /* the bounds are set as rems so we are sized relative to the user's custom font size setting */
  font-size: clamp(0.88rem, 0.19vw + 0.84rem, 1.06rem);
  font-weight: 300;
  color: white;
  --text-selection-color: #b0d3fa;
}
.wildidea ::selection,.wildidea mark {
    background-color: var(--text-selection-color);
  }
.wildidea header,.wildidea h1,.wildidea h2,.wildidea h3,.wildidea h4 {
    text-rendering: optimizeLegibility;
  }
.wildidea h1 {
    font-family: var(--heading-font);
    font-size: 1.8em;
    margin: 0.8em 0 0.3em;
  }
.wildidea h1 small {
      display: block;
      font-family: var(--subheading-font);
      font-size: 0.5em;
      font-weight: normal;
      color: var(--color-blue-1);
    }
.wildidea h2 {
    font-family: var(--subheading-font);
    font-size: 1.5em;
    font-weight: normal;
    margin: 0.8em 0 0.8em;
  }
.wildidea h2 small {
      display: block;
      margin-top: 0.3em;
      font-family: var(--heading-font);
      font-size: 0.8em;
      font-weight: normal;
      color: var(--color-blue-1);
    }
.wildidea h3 {
    font-family: var(--heading-font);
    font-size: 1.7em;
    font-weight: normal;
    margin: 2em 0 0.4em;
  }
.wildidea h4 {
    font-family: var(--subheading-font);
    font-size: 0.9em;
    font-weight: normal;
    margin: 1.8em 0 0.5em;
  }
.wildidea a,.wildidea .a {
    color: inherit;
    transition: color var(--default-transition-duration);
    border-radius: var(--button-border-radius);
    -webkit-text-decoration: underline;
    text-decoration: underline;
    text-underline-offset: 0.2em;
    text-decoration-thickness: 0.07em;
    cursor: pointer;
  }
.wildidea a:not(.does-not-exist):focus,.wildidea .a:focus {
      outline: var(--default-focus-outline);
      outline-offset: 3px;
    }
.wildidea a:not(.does-not-exist):active {
      color: var(--color-blue-1);
    }
.wildidea .a:active {
      color: var(--color-blue-1);
    }
.wildidea.touch-only .wild-button,.wildidea.touch-only a {
      /* All of our interactions have high visible changes */
      outline: none !important;
    }
.wildidea p {
    margin: 0 0 1.5em;
  }
.wildidea b,.wildidea strong {
    font-weight: bold;
  }
.wildidea code,.wildidea pre {
    font-family: var(--monospace-font);
  }
.wildidea hr {
    width: 100%;
    border: none;
    border-bottom: 1px solid var(--color-grey-2);
    margin-bottom: 1.5em;
  }
.wildidea h1 mark::before {
        font-size: 1.3em;
        font-weight: normal;
      }
.wildidea h2 mark::before {
        font-size: 1.3em;
        font-weight: normal;
      }
.wildidea h3 mark::before {
        font-size: 1.3em;
        font-weight: normal;
      }
.wildidea h4 mark::before {
        font-size: 1.3em;
        font-weight: normal;
      }
.wildidea h1 mark::after {
        font-size: 1.3em;
        font-weight: normal;
      }
.wildidea h2 mark::after {
        font-size: 1.3em;
        font-weight: normal;
      }
.wildidea h3 mark::after {
        font-size: 1.3em;
        font-weight: normal;
      }
.wildidea h4 mark::after {
        font-size: 1.3em;
        font-weight: normal;
      }

/* Font Scaling from 1920px-4k */
@media (min-width: 1920px) {
  .wildidea {
    font-size: clamp(1.06rem, 0.99vw - 0.13rem, 2.25rem);
    font-size: clamp(1.06rem, 0.99vi - 0.13rem, 2.25rem);
  }
}

@keyframes fadeInMarkColors {
  from {
    color: inherit;
    background: transparent;
  }
  to {
    color: black;
    background: white;
  }
}

@keyframes bracketLeft {
  0% {
    transform: scaleY(1.2) translateX(-200%);
    opacity: 0;
  }
  100% {
    transform: scaleY(1) translateX(0);
    opacity: 1;
  }
}

@keyframes bracketRight {
  0% {
    transform: scaleY(1.2) translateX(200%);
    opacity: 0;
  }
  100% {
    transform: scaleY(1) translateX(0);
    opacity: 1;
  }
}
`, "",{"version":3,"sources":["webpack://./src/theme/typography.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,4CAAmC;EACnC,kBAAkB;AACpB;AACA;EACE,wBAAwB;EACxB,4CAAgC;EAChC,kBAAkB;AACpB;;AAEA;EACE,4BAA4B;EAC5B,oCAAoC;EACpC,mEAAmE;AACrE;;AAEA,wCAAwC;AACxC;EACE,6BAA6B;EAC7B,mDAAmD;EACnD,+FAA+F;EAC/F,oDAAoD;EACpD,gBAAgB;EAChB,YAAY;EACZ,+BAA+B;AAsHjC;AApHE;IAEE,6CAA6C;EAC/C;AAEA;IAKE,kCAAkC;EACpC;AAEA;IACE,gCAAgC;IAChC,gBAAgB;IAChB,qBAAqB;EASvB;AAPE;MACE,cAAc;MACd,mCAAmC;MACnC,gBAAgB;MAChB,mBAAmB;MACnB,0BAA0B;IAC5B;AAGF;IACE,mCAAmC;IACnC,gBAAgB;IAChB,mBAAmB;IACnB,qBAAqB;EAUvB;AARE;MACE,cAAc;MACd,iBAAiB;MACjB,gCAAgC;MAChC,gBAAgB;MAChB,mBAAmB;MACnB,0BAA0B;IAC5B;AAGF;IACE,gCAAgC;IAChC,gBAAgB;IAChB,mBAAmB;IACnB,mBAAmB;EACrB;AAEA;IACE,mCAAmC;IACnC,gBAAgB;IAChB,mBAAmB;IACnB,qBAAqB;EACvB;AAEA;IAEE,cAAc;IACd,oDAAoD;IACpD,0CAA0C;IAC1C,kCAA0B;IAA1B,0BAA0B;IAC1B,4BAA4B;IAC5B,iCAAiC;IACjC,eAAe;EAQjB;AAPE;MACE,qCAAqC;MACrC,mBAAmB;IACrB;AACA;MACE,0BAA0B;IAC5B;AAFA;MACE,0BAA0B;IAC5B;AAIA;MAEE,sDAAsD;MACtD,wBAAwB;IAC1B;AAGF;IACE,iBAAiB;EACnB;AAEA;IAEE,iBAAiB;EACnB;AAEA;IAEE,kCAAkC;EACpC;AAEA;IACE,WAAW;IACX,YAAY;IACZ,4CAA4C;IAC5C,oBAAoB;EACtB;AAOI;QAEE,gBAAgB;QAChB,mBAAmB;MACrB;AAJA;QAEE,gBAAgB;QAChB,mBAAmB;MACrB;AAJA;QAEE,gBAAgB;QAChB,mBAAmB;MACrB;AAJA;QAEE,gBAAgB;QAChB,mBAAmB;MACrB;AAJA;QAEE,gBAAgB;QAChB,mBAAmB;MACrB;AAJA;QAEE,gBAAgB;QAChB,mBAAmB;MACrB;AAJA;QAEE,gBAAgB;QAChB,mBAAmB;MACrB;AAJA;QAEE,gBAAgB;QAChB,mBAAmB;MACrB;;AAKN,gCAAgC;AAChC;EACE;IACE,oDAAoD;IAApD,oDAAoD;EACtD;AACF;;AAEA;EACE;IACE,cAAc;IACd,uBAAuB;EACzB;EACA;IACE,YAAY;IACZ,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,wCAAwC;IACxC,UAAU;EACZ;EACA;IACE,kCAAkC;IAClC,UAAU;EACZ;AACF;;AAEA;EACE;IACE,uCAAuC;IACvC,UAAU;EACZ;EACA;IACE,kCAAkC;IAClC,UAAU;EACZ;AACF","sourcesContent":["@font-face {\n  font-family: 'Museo Slab';\n  src: url('./fonts/Museo Slab.woff');\n  font-display: swap;\n}\n@font-face {\n  font-family: 'Open Sans';\n  src: url('./fonts/OpenSans.ttf');\n  font-display: swap;\n}\n\n.wildidea {\n  --heading-font: 'Museo Slab';\n  --body-font: 'Open Sans', sans-serif;\n  --monospace-font: Menlo, Monaco, Consolas, 'Courier New', monospace;\n}\n\n/* begin structural style applications */\n.wildidea {\n  font-family: var(--body-font);\n  /* Font Scaling from 320px - 1920px (4k is below) */\n  /* the bounds are set as rems so we are sized relative to the user's custom font size setting */\n  font-size: clamp(0.88rem, 0.19vw + 0.84rem, 1.06rem);\n  font-weight: 300;\n  color: white;\n  --text-selection-color: #b0d3fa;\n\n  & ::selection,\n  mark {\n    background-color: var(--text-selection-color);\n  }\n\n  & header,\n  & h1,\n  & h2,\n  & h3,\n  & h4 {\n    text-rendering: optimizeLegibility;\n  }\n\n  & h1 {\n    font-family: var(--heading-font);\n    font-size: 1.8em;\n    margin: 0.8em 0 0.3em;\n\n    & small {\n      display: block;\n      font-family: var(--subheading-font);\n      font-size: 0.5em;\n      font-weight: normal;\n      color: var(--color-blue-1);\n    }\n  }\n\n  & h2 {\n    font-family: var(--subheading-font);\n    font-size: 1.5em;\n    font-weight: normal;\n    margin: 0.8em 0 0.8em;\n\n    & small {\n      display: block;\n      margin-top: 0.3em;\n      font-family: var(--heading-font);\n      font-size: 0.8em;\n      font-weight: normal;\n      color: var(--color-blue-1);\n    }\n  }\n\n  & h3 {\n    font-family: var(--heading-font);\n    font-size: 1.7em;\n    font-weight: normal;\n    margin: 2em 0 0.4em;\n  }\n\n  & h4 {\n    font-family: var(--subheading-font);\n    font-size: 0.9em;\n    font-weight: normal;\n    margin: 1.8em 0 0.5em;\n  }\n\n  & a,\n  .a {\n    color: inherit;\n    transition: color var(--default-transition-duration);\n    border-radius: var(--button-border-radius);\n    text-decoration: underline;\n    text-underline-offset: 0.2em;\n    text-decoration-thickness: 0.07em;\n    cursor: pointer;\n    &:focus {\n      outline: var(--default-focus-outline);\n      outline-offset: 3px;\n    }\n    &:active {\n      color: var(--color-blue-1);\n    }\n  }\n\n  &.touch-only {\n    .wild-button,\n    a {\n      /* All of our interactions have high visible changes */\n      outline: none !important;\n    }\n  }\n\n  & p {\n    margin: 0 0 1.5em;\n  }\n\n  & b,\n  & strong {\n    font-weight: bold;\n  }\n\n  & code,\n  & pre {\n    font-family: var(--monospace-font);\n  }\n\n  & hr {\n    width: 100%;\n    border: none;\n    border-bottom: 1px solid var(--color-grey-2);\n    margin-bottom: 1.5em;\n  }\n\n  & h1,\n  & h2,\n  & h3,\n  & h4 {\n    & mark {\n      &::before,\n      &::after {\n        font-size: 1.3em;\n        font-weight: normal;\n      }\n    }\n  }\n}\n\n/* Font Scaling from 1920px-4k */\n@media (min-width: 1920px) {\n  .wildidea {\n    font-size: clamp(1.06rem, 0.99vi - 0.13rem, 2.25rem);\n  }\n}\n\n@keyframes fadeInMarkColors {\n  from {\n    color: inherit;\n    background: transparent;\n  }\n  to {\n    color: black;\n    background: white;\n  }\n}\n\n@keyframes bracketLeft {\n  0% {\n    transform: scaleY(1.2) translateX(-200%);\n    opacity: 0;\n  }\n  100% {\n    transform: scaleY(1) translateX(0);\n    opacity: 1;\n  }\n}\n\n@keyframes bracketRight {\n  0% {\n    transform: scaleY(1.2) translateX(200%);\n    opacity: 0;\n  }\n  100% {\n    transform: scaleY(1) translateX(0);\n    opacity: 1;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
